import { CreateCredentialingEmailDraft } from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function CreateDraftMail(payload = {}) {
    try {
        const requestPayload = {
              payload,
        }

        const res = await getCharts(CreateCredentialingEmailDraft, requestPayload)
        return res.data
    } catch (error) {
        return error
    }
}